import React from 'react'
import * as styles from './icon.module.css'

const icons = {
  alert: {
    src: '/images/icons/alert.svg',
    alt: 'Alert Icon',
  },
  animalfeed: {
    src: '/images/icons/animalfeed.svg',
    alt: 'Animal Feed Icon',
  },
  arrow: {
    src: '/images/icons/arrowright.svg',
    alt: 'Arrow Pointing Right Icon',
  },
  arrowleft: {
    src: '/images/icons/arrowleft.svg',
    alt: 'Arrow Pointing Left Icon',
  },
  award: {
    src: '/images/icons/award.svg',
    alt: 'Award Icon',
  },
  badge: {
    src: '/images/icons/badge.svg',
    alt: 'Badge Icon',
  },
  cake: {
    src: '/images/icons/cake.svg',
    alt: 'Cake Icon',
  },
  cake2: {
    src: '/images/icons/cake-2.svg',
    alt: 'Cake with Candles Icon',
  },
  calendar: {
    src: '/images/icons/calendar.svg',
    alt: 'Calendar Icon',
  },
  caricature: {
    src: '/images/icons/caricaturist.svg',
    alt: 'Caricaturist Icon',
  },
  carousel: {
    src: '/images/icons/carousel.svg',
    alt: 'Carousel Icon',
  },
  chalkboard: {
    src: '/images/icons/chalkboard.svg',
    alt: 'Chalkboard Icon',
  },
  check: {
    src: '/images/icons/check.svg',
    alt: 'Checkmark Icon',
  },
  clock: {
    src: '/images/icons/clock.svg',
    alt: 'Clock Icon',
  },
  clockBold: {
    src: '/images/icons/clock-bold.svg',
    alt: 'Clock Bold Icon',
  },
  close: {
    src: '/images/icons/close.svg',
    alt: 'Close Icon',
  },
  expand: {
    src: '/images/icons/down.svg',
    alt: 'Down Icon',
  },
  cupcake: {
    src: '/images/icons/cupcake.svg',
    alt: 'Cupcake Icon',
  },
  decorations: {
    src: '/images/icons/balloons.svg',
    alt: 'Balloons Icon',
  },
  elephant: {
    src: '/images/icons/elephant.svg',
    alt: 'Elephant Icon',
  },
  email: {
    src: '/images/icons/email.svg',
    alt: 'Email Icon',
  },
  modal: {
    src: '/images/icons/icon-modal.svg',
    alt: 'Modal Open Icon',
  },
  collapse: {
    src: '/images/icons/up.svg',
    alt: 'Up Arrow Icon',
  },
  facepaint: {
    src: '/images/icons/facepaint.svg',
    alt: 'Facepaint Icon',
  },
  fb: {
    src: '/images/icons/fb.svg',
    alt: 'Facebook Icon',
  },
  food: {
    src: '/images/icons/food.svg',
    alt: 'Food Icon',
  },
  fish1: {
    src: '/images/icons/fish1.svg',
    alt: 'Fish Icon',
  },
  fish2: {
    src: '/images/icons/fish2.svg',
    alt: 'Fish Icon',
  },
  fish3: {
    src: '/images/icons/fish3.svg',
    alt: 'Fish Icon',
  },
  fish4: {
    src: '/images/icons/fish4.svg',
    alt: 'Fish Icon',
  },
  fish5: {
    src: '/images/icons/fish5.svg',
    alt: 'Fish Icon',
  },
  fish6: {
    src: '/images/icons/fish6.svg',
    alt: 'Fish Icon',
  },
  fotz: {
    src: '/images/icons/fotz.svg',
    alt: 'FOTZ Icon',
  },
  globe: {
    src: '/images/icons/globe.svg',
    alt: 'Globe icon to indicate translation options',
  },
  'group of friends': {
    src: '/images/icons/group.svg',
    alt: 'Group Icon',
  },
  hamburgermenu: {
    src: '/images/icons/hamburgermenu.svg',
    alt: 'Hamburgermenu Icon',
  },
  heart: {
    src: '/images/icons/heart.svg',
    alt: 'Heart Icon',
  },
  hippo: {
    src: '/images/icons/hippo.svg',
    alt: 'hippo Icon',
  },
  home: {
    src: '/images/icons/home.svg',
    alt: 'Home Icon',
  },
  instagram: {
    src: '/images/icons/instagram.svg',
    alt: 'Instagram Icon',
  },
  kraken: {
    src: '/images/icons/kraken.svg',
  },
  leaf: {
    src: '/images/icons/leaf-regular.svg',
    alt: 'Leaf Icon',
  },
  lion: {
    src: '/images/icons/lion.svg',
    alt: 'Lion Icon',
  },
  location: {
    src: '/images/icons/location.svg',
    alt: 'Location Icon',
  },
  map: {
    src: '/images/icons/map.svg',
    alt: 'Map Icon',
  },
  media: {
    src: '/images/icons/media.svg',
    alt: 'Media Icon',
  },
  minus: {
    src: '/images/icons/minus.svg',
    alt: 'Minus Icon',
  },
  monkey: {
    src: '/images/icons/monkey.svg',
    alt: 'Monkey Icon',
  },
  newsletter: {
    src: '/images/icons/newsletter.svg',
    alt: 'Newsletter Icon',
  },
  next: {
    src: '/images/icons/next.svg',
    alt: 'Next Icon',
  },
  otter: {
    src: '/images/icons/otter.svg',
    alt: 'Otter Icon',
  },
  penguin: {
    src: '/images/icons/penguin.svg',
    alt: 'Penguin Icon',
  },
  pizza: {
    src: '/images/icons/pizza.svg',
    alt: 'Pizza Icon',
  },
  plus: {
    src: '/images/icons/plus.svg',
    alt: 'Plus Icon',
  },
  plush: {
    src: '/images/icons/plush.svg',
    alt: 'Plush Icon',
  },
  polarbear: {
    src: '/images/icons/polarbear.svg',
    alt: 'Polarbear Icon',
  },
  previous: {
    src: '/images/icons/previous.svg',
    alt: 'Previous Arrow Icon',
  },
  register: {
    src: '/images/icons/register.svg',
    alt: 'Register Icon',
  },
  gift: {
    src: '/images/gift.svg',
    alt: 'Gift Icon',
  },
  rides: {
    src: '/images/icons/train.svg',
    alt: 'Train Icon',
  },
  'sea-lion': {
    src: '/images/icons/sealion.svg',
    alt: 'Sealion Icon',
  },
  search: {
    src: '/images/icons/search.svg',
    alt: 'Search Icon',
  },
  searchBold: {
    src: '/images/icons/search-bold.svg',
    alt: 'Search Bold Icon',
  },
  smiley: {
    src: '/images/icons/smiley.svg',
    alt: 'Smiley Face Icon',
  },
  tent: {
    src: '/images/icons/tent.svg',
    alt: 'Tent Icon',
  },
  tickets: {
    src: '/images/icons/tickets.svg',
    alt: 'Tickets Icon',
  },
  tiger: {
    src: '/images/icons/tiger.svg',
    alt: 'Tiger Icon',
  },
  twitter: {
    src: '/images/icons/twitter.svg',
    alt: 'Twitter Icon',
  },
  wristband: {
    src: '/images/icons/wristband.svg',
    alt: 'Wristband Icon',
  },
  youtube: {
    src: '/images/icons/youtube.svg',
    alt: 'Youtube logo Icon',
  },
  'zoo-bucks': {
    src: '/images/icons/zoobucks.svg',
    alt: 'Zoobucks Icon',
  },
  baboon: {
    src: '/images/icon-baboon.svg',
    alt: 'Baboon Icon',
  },
  giraffe: {
    src: '/images/icon-giraffe.svg',
    alt: 'Giraffe Icon',
  },
  flamingo: {
    src: '/images/icon-flamingo.svg',
    alt: 'Flamingo Icon',
  },
  postcard: {
    src: '/images/icon-postcard.svg',
    alt: 'Postcard Icon',
  },
  'map-camel': {
    src: '/images/icons/map-camel.svg',
    alt: 'Camel Icon',
  },
  'map-chimpanzee': {
    src: '/images/icons/map-chimpanzee.svg',
    alt: 'Chimpanzee Icon',
  },
  'map-elephant': {
    src: '/images/icons/map-elephant.svg',
    alt: 'Elephant Icon',
  },
  'map-giraffe': {
    src: '/images/icons/map-giraffe.svg',
    alt: 'Giraffe Icon',
  },
  'map-hippo': {
    src: '/images/icons/map-hippo.svg',
    alt: 'Hippo Icon',
  },
  'map-orangutan': {
    src: '/images/icons/map-orangutan.svg',
    alt: 'Orangutan Icon',
  },
  'map-penguin': {
    src: '/images/icons/map-penguin.svg',
    alt: 'Penguin Icon',
  },
  'map-tamarin': {
    src: '/images/icons/map-tamarin.svg',
    alt: 'Tamarin Icon',
  },
  'map-shows': {
    src: '/images/icons/map-shows.svg',
    alt: 'Shows Icon',
  },
  'map-veterinary': {
    src: '/images/icons/map-veterinary.svg',
    alt: 'Veterinary Icon',
  },
  'map-gift': {
    src: '/images/icons/map-gift.svg',
    alt: 'Gift Icon',
  },
}

const colors = {
  'ZOO GREEN': {
    mods: 'invert(47%) sepia(8%) saturate(3283%) hue-rotate(74deg) brightness(121%) contrast(90%)',
  },
  'ZOO BLUE': {
    mods: 'invert(33%) sepia(90%) saturate(714%) hue-rotate(158deg) brightness(102%) contrast(105%)',
  },
  ORCHID: {
    mods: 'invert(33%) sepia(53%) saturate(1187%) hue-rotate(296deg) brightness(86%) contrast(84%)',
  },
  TANGERINE: {
    mods: 'invert(61%) sepia(63%) saturate(453%) hue-rotate(343deg) brightness(102%) contrast(97%)',
  },
  SEA: {
    mods: 'invert(68%) sepia(7%) saturate(3182%) hue-rotate(107deg) brightness(90%) contrast(98%)',
  },
  'TERRA COTTA': {
    mods: 'invert(31%) sepia(23%) saturate(4113%) hue-rotate(334deg) brightness(96%) contrast(84%)',
  },
  PUMPKIN: {
    mods: 'invert(71%) sepia(54%) saturate(6568%) hue-rotate(334deg) brightness(102%) contrast(98%)',
  },
  CANARY: {
    mods: 'invert(82%) sepia(71%) saturate(664%) hue-rotate(323deg) brightness(104%) contrast(101%)',
  },
  WHITE: {
    mods: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)',
  },
  GREY: {
    mods: 'invert(45%) sepia(0%) saturate(0%) hue-rotate(252deg) brightness(95%) contrast(87%)',
  },
  'JAZZOO-RED': {
    mods: 'invert(42%) sepia(86%) saturate(749%) hue-rotate(342deg) brightness(90%) contrast(96%)',
  },
  'JAZZOO-ORANGE': {
    mods: 'invert(73%) sepia(54%) saturate(1166%) hue-rotate(324deg) brightness(105%) contrast(97%)',
  },
  'JAZZOO-GREEN': {
    mods: 'invert(81%) sepia(5%) saturate(2614%) hue-rotate(78deg) brightness(95%) contrast(77%)',
  },
  'JAZZOO-LIGHT-GREEN': {
    mods: 'invert(84%) sepia(50%) saturate(600%) hue-rotate(17deg) brightness(95%) contrast(82%)',
  },
  'JAZZOO-BLUE': {
    mods: 'invert(91%) sepia(28%) saturate(3535%) hue-rotate(163deg) brightness(93%) contrast(95%)',
  },
  BLACK: {
    mods: '',
  },
}

export default ({
  icon = 'alert',
  className,
  height,
  width,
  color = 'BLACK',
  style = true,
  alt,
}) => {

  const iconStyle = style
    ? {
        filter: `brightness(0) saturate(100%) ${
          colors[color.toUpperCase()].mods || ''
        }`,
      }
    : {};

  return (
    <img
      src={icons[icon] ? icons[icon].src : icons['alert'].src}
      className={className}
      height={height}
      width={width}
      alt={alt || icons[icon] ? icons[icon].alt : ''}
      style={iconStyle}
    />
  )
}
